var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.737,
    height: 20.737,
    viewBox: "0 0 20.737 20.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.44,0H1.3A1.3,1.3,0,0,0,.381,2.213l7.4,7.4v7.564a1.3,1.3,0,0,0,.443.975l2.592,2.267a1.3,1.3,0,0,0,2.15-.975V9.609l7.4-7.4A1.3,1.3,0,0,0,19.44,0ZM11.665,9.073V19.441L9.073,17.173v-8.1L1.3,1.3H19.441Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c81b3b3a02712444dcfccce7ba051dbe.svg";
export { ForwardRef as ReactComponent };